import styled from 'styled-components';

// Container principal du footer
export const FooterContainer = styled.footer`
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #1a1d3d 0%, #252952 100%);
  color: #ffffff;
  padding: 12vw 6vw 8vw 6vw;
  align-items: center;
  font-family: "Raleway", sans-serif;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;

  /* Tablet */
  @media (min-width: 768px) {
    padding: 8vw 5vw 6vw 5vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    padding: 5.76vw 5.448vw;
  }
`;

// Grille principale des colonnes
export const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 8vw;
  margin-bottom: 8vw;
  width: 100%;
  max-width: 100%;

  /* Tablet */
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 5vw;
    margin-bottom: 6vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
    gap: 3vw;
    margin-bottom: 3vw;
  }
`;

// Colonne individuelle
export const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

// Titre de colonne
export const ColumnTitle = styled.h3`
  font-size: 5vw;
  font-weight: 600;
  margin-bottom: 4vw;
  color: #ffffff;
  letter-spacing: 0.3px;
  font-family: "Raleway", sans-serif;

  /* Tablet */
  @media (min-width: 768px) {
    font-size: 3vw;
    margin-bottom: 3vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 1.1vw;
    margin-bottom: 1.5vw;
  }
`;

// Liste de liens
export const LinkList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const LinkItem = styled.li`
  margin-bottom: 3vw;

  /* Tablet */
  @media (min-width: 768px) {
    margin-bottom: 2vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    margin-bottom: 0.8vw;
  }
`;

export const Link = styled.a`
  color: ${props => props.$isHovered ? '#ffffff' : '#b8bcd9'};
  text-decoration: none;
  font-size: 4vw;
  font-weight: 400;
  letter-spacing: 0.2px;
  transition: color 0.3s ease;
  cursor: pointer;
  display: block;
  font-family: "Raleway", sans-serif;

  /* Tablet */
  @media (min-width: 768px) {
    font-size: 2.5vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 0.9vw;
  }

  &:hover {
    color: #ffffff;
  }
`;

// Box Newsletter
export const NewsletterBox = styled.div`
  background: rgba(58, 63, 107, 0.4);
  border-radius: 3vw;
  padding: 6vw;
  backdrop-filter: blur(10px);
  width: 100%;
  box-sizing: border-box;
  font-family: "Raleway", sans-serif;

  /* Tablet */
  @media (min-width: 768px) {
    grid-column: span 2;
    border-radius: 2vw;
    padding: 4vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    grid-column: span 1;
    border-radius: 0.8vw;
    padding: 2vw;
  }
`;

// Formulaire email
export const EmailForm = styled.div`
  display: flex;
  margin-bottom: 4vw;
  width: 100%;
  max-width: 100%;

  /* Desktop */
  @media (min-width: 1024px) {
    margin-bottom: 1.5vw;
  }
`;

export const EmailInput = styled.input`
  flex: 1;
  padding: 4vw;
  border: none;
  border-radius: 2vw 0 0 2vw;
  background: #ffffff;
  font-size: 4vw;
  color: #1a1d3d;
  outline: none;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  font-family: "Raleway", sans-serif;

  /* Tablet */
  @media (min-width: 768px) {
    padding: 2.5vw;
    font-size: 2.5vw;
    border-radius: 1.5vw 0 0 1.5vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    padding: 0.8vw 1vw;
    font-size: 0.8vw;
    border-radius: 0.4vw 0 0 0.4vw;
  }

  &::placeholder {
    color: rgba(26, 29, 61, 0.5);
  }
`;

export const SubmitBtn = styled.button`
  background: #ff5722;
  border: none;
  padding: 4vw 6vw;
  border-radius: 0 2vw 2vw 0;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 5vw;
  font-weight: bold;
  flex-shrink: 0;
  min-width: auto;
  font-family: "Raleway", sans-serif;

  /* Tablet */
  @media (min-width: 768px) {
    padding: 2.5vw 5vw;
    font-size: 3.5vw;
    border-radius: 0 1.5vw 1.5vw 0;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    padding: 0.8vw 1.5vw;
    font-size: 1vw;
    border-radius: 0 0.4vw 0.4vw 0;
  }

  &:hover {
    background: #e64a19;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const NewsletterText = styled.p`
  color: #b8bcd9;
  font-size: 3.5vw;
  line-height: 1.5;
  letter-spacing: 0.2px;
  margin: 0;
  font-family: "Raleway", sans-serif;

  /* Tablet */
  @media (min-width: 768px) {
    font-size: 2.2vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 0.75vw;
  }
`;

// Séparateur
export const FooterSeparator = styled.div`
  height: 0.3vw;
  background: rgba(184, 188, 217, 0.15);
  margin: 0 0 6vw 0;
  width: 100%;

  /* Tablet */
  @media (min-width: 768px) {
    margin: 0 0 4vw 0;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    height: 0.1vw;
    margin: 0 0 2.5vw 0;
  }
`;

// Bas du footer
export const FooterBottom = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 6vw;

  /* Tablet */
  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    gap: 4vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    gap: 2vw;
  }
`;

// Logo
export const FooterLogo = styled.div`
  display: flex;
  align-items: center;
  order: 1;

  /* Desktop */
  @media (min-width: 1024px) {
    order: 1;
  }
`;

export const LogoImage = styled.img`
  height: 10vw;
  width: auto;

  /* Tablet */
  @media (min-width: 768px) {
    height: 6vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    height: 2.5vw;
  }
`;

// Liens du bas
export const FooterLinks = styled.div`
  display: flex;
  gap: 5vw;
  flex-wrap: wrap;
  justify-content: center;
  order: 2;

  /* Tablet */
  @media (min-width: 768px) {
    gap: 4vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    gap: 3vw;
    order: 2;
    flex: 1;
  }
`;

export const FooterLink = styled.a`
  color: ${props => props.$isHovered ? '#ffffff' : '#b8bcd9'};
  text-decoration: none;
  font-size: 3.5vw;
  font-weight: 400;
  transition: color 0.3s ease;
  cursor: pointer;
  white-space: nowrap;
  font-family: "Raleway", sans-serif;

  /* Tablet */
  @media (min-width: 768px) {
    font-size: 2.2vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 0.8vw;
  }

  &:hover {
    color: #ffffff;
  }
`;

// Icônes sociales
export const SocialIcons = styled.div`
  display: flex;
  gap: 4vw;
  order: 3;

  /* Tablet */
  @media (min-width: 768px) {
    gap: 2vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    gap: 1vw;
    order: 3;
  }
`;

export const SocialIcon = styled.a`
  width: 12vw;
  height: 12vw;
  border-radius: 50%;
  background: ${props => props.$isHovered 
    ? 'rgba(78, 83, 127, 0.7)' 
    : 'rgba(58, 63, 107, 0.5)'};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  color: #ffffff;
  font-size: 5vw;
  font-family: "Raleway", sans-serif;
  transform: ${props => props.$isHovered ? 'translateY(-0.5vw)' : 'translateY(0)'};

  /* Tablet */
  @media (min-width: 768px) {
    width: 8vw;
    height: 8vw;
    font-size: 3.5vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    width: 2.5vw;
    height: 2.5vw;
    font-size: 0.9vw;
    transform: ${props => props.$isHovered ? 'translateY(-2px)' : 'translateY(0)'};
  }

  &:hover {
    background: rgba(78, 83, 127, 0.7);
    transform: translateY(-0.5vw);

    @media (min-width: 1024px) {
      transform: translateY(-2px);
    }
  }
`;

// Export des styles pour compatibilité
export const footerStyles = {
  columnTitle: {},
  linkList: {},
  linkItem: {},
  link: {},
  newsletterBox: {},
  emailForm: {},
  emailInput: {},
  submitBtn: {},
  newsletterText: {},
  footerSeparator: {},
  footerLogo: {},
  logoImage: {},
  footerLinks: {},
  footerLink: {},
  socialIcons: {},
  socialIcon: {},
};

export const responsiveStyles = {};